import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "titleId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { createElement } from 'react';
import { CreateSVG } from "../lib/index.js";
function SvgIconChild(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/createElement(CreateSVG, _objectSpread(_objectSpread({}, props), {}, {
    renderIcon: function renderIcon(props) {
      return /*#__PURE__*/React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 52 52",
        xmlSpace: "preserve",
        enableBackground: "new 0 0 52 52",
        "aria-labelledby": titleId
      }, props), title ? /*#__PURE__*/React.createElement("title", {
        id: titleId
      }, title) : null, /*#__PURE__*/React.createElement("style", {
        type: "text/css"
      }, '.Icon-child_svg__st0{display:none}.Icon-child_svg__st1{display:inline;fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-child_svg__st2{display:inline}.Icon-child_svg__st3{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-child_svg__st4{fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-child_svg__st5{display:inline;fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-child_svg__st6{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10}.Icon-child_svg__st7{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10}.Icon-child_svg__st8{fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10}.Icon-child_svg__st9{stroke:#000000;stroke-width:2;stroke-miterlimit:10}.Icon-child_svg__st10{fill:none;stroke:#000000;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10}.Icon-child_svg__st11{fill:none;stroke:#000000;stroke-width:4;stroke-linejoin:round;stroke-miterlimit:10}.Icon-child_svg__st12{stroke:#000000;stroke-width:0.4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-child_svg__st13{stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-child_svg__st14{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}.Icon-child_svg__st15{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0.1032,4.127}.Icon-child_svg__st16{display:inline;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.Icon-child_svg__st17{fill:none}'), /*#__PURE__*/React.createElement("g", {
        id: "Icon-child_svg__stroke",
        className: "Icon-child_svg__st0"
      }, /*#__PURE__*/React.createElement("g", {
        className: "Icon-child_svg__st2"
      }, /*#__PURE__*/React.createElement("path", {
        className: "Icon-child_svg__st10",
        d: "M19,29c0,1.0625,1,2,2,2h10c1,0,2-1,2-2v-6c0-3-2.1875-4-5-4h-4c-3,0-5,1-5,4V29z"
      }), /*#__PURE__*/React.createElement("circle", {
        className: "Icon-child_svg__st7",
        cx: 26,
        cy: 10,
        r: 5
      }), /*#__PURE__*/React.createElement("polyline", {
        className: "Icon-child_svg__st10",
        points: "21,30.5 21,39 31,39 31,30.5  "
      }), /*#__PURE__*/React.createElement("line", {
        className: "Icon-child_svg__st3",
        x1: 26,
        y1: 38,
        x2: 26,
        y2: 36
      }), /*#__PURE__*/React.createElement("line", {
        className: "Icon-child_svg__st3",
        x1: 23,
        y1: 39,
        x2: 23,
        y2: 47
      }), /*#__PURE__*/React.createElement("line", {
        className: "Icon-child_svg__st3",
        x1: 29,
        y1: 39,
        x2: 29,
        y2: 47
      }))), /*#__PURE__*/React.createElement("g", {
        id: "Icon-child_svg__filled"
      }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
        cx: 26,
        cy: 10,
        r: 6
      }), /*#__PURE__*/React.createElement("path", {
        d: "M29,48c0.5522,0,1-0.4473,1-1v-7h1c0.5522,0,1-0.4473,1-1v-6H20v6c0,0.5527,0.4478,1,1,1h1v7c0,0.5527,0.4478,1,1,1 s1-0.4473,1-1v-7h1v-4c0-0.5527,0.4478-1,1-1s1,0.4473,1,1v4h1v7C28,47.5527,28.4478,48,29,48z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M34,29v-6c0-1.8672-0.7793-5-6-5h-4c-4.959,0-6,2.7188-6,5v6c0,0.7479,0.3279,1.4581,0.8383,2h14.3052 C33.6627,30.4536,34,29.7389,34,29z"
      }))));
    }
  }));
}
export default SvgIconChild;